import { AnalyticsEvent } from '../Model/analytics.event';

/**
 * Abstract class representing a Firebase Error Logger.
 * This class is intended for logging error events into Firebase.
 */
export abstract class FirebaseErrorLogger {
    abstract logError(event: AnalyticsEvent, error: unknown): Promise<void>;
}
